import { rewriteCss } from "@rewriters/css";
import { VortexClient } from "@client/index";

export default function (client: VortexClient, _self: Self) {
	client.Proxy("FontFace", {
		construct(ctx) {
			ctx.args[1] = rewriteCss(ctx.args[1], client.meta);
		},
	});
}
